import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import API from '../services/api';
import { useAuth } from '../context/AuthContext';

const POLL_MS = 60 * 1000;

const PedidosBadgeContext = createContext({ pending: 0, open: 0, refresh: () => {} });

// How many CG Connect pedidos (Conduces → "Pedidos de clientes") still need someone: the header bell and the
// dashboard card share this one poll instead of each fetching it themselves. Same refresh triggers as
// ApprovalProvider (route change, window focus, every minute).
export const usePedidosBadge = () => useContext(PedidosBadgeContext);

const PedidosBadgeProvider = ({ children }) => {
  const { isLoggedIn, mustChangePassword } = useAuth();
  const location = useLocation();
  const [counts, setCounts] = useState({ pending: 0, open: 0 });

  const refresh = useCallback(async () => {
    if (!isLoggedIn || mustChangePassword || !localStorage.getItem('token')) { setCounts({ pending: 0, open: 0 }); return; }
    try {
      const res = await API.get('/order-requests/count');
      setCounts(res.data);
    } catch (err) { /* keep what was there; the next tick tries again */ }
  }, [isLoggedIn, mustChangePassword]);

  useEffect(() => { refresh(); }, [refresh, location.pathname]);
  useEffect(() => {
    const timer = setInterval(refresh, POLL_MS);
    window.addEventListener('focus', refresh);
    return () => { clearInterval(timer); window.removeEventListener('focus', refresh); };
  }, [refresh]);

  return (
    <PedidosBadgeContext.Provider value={{ ...counts, refresh }}>
      {children}
    </PedidosBadgeContext.Provider>
  );
};

export default PedidosBadgeProvider;
